/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
} from 'react';

import './animation015.less';
import { usePlayFlag } from './../../components/topicScroll';
import imageArrow from '../../../../../assets/a015-arrow.svg';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation015Item {
  color: string;
  text: string;
}

interface IAnimation015Props {
  items: IAnimation015Item[];
  className?: string | null;
  onCompleted: () => void;
}

const Animation015: FunctionComponent<IAnimation015Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation015 onCompleted');
      onCompleted && onCompleted();
    }
  };
  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <div ref={crrRef} className={`animation015 component ${className}`}>
      {items.map((itm: IAnimation015Item, idx: number) => (
        <div
          onClick={() => clickToPlay()}
          key={idx}
          className={`animation015-item r${idx} animation ${
            play >= idx + 1 ? 'fade-in' : ''
          }`}
          style={{ paddingLeft: idx * 75 }}
        >
          <img
            className="click-point"
            onClick={() => clickToPlay()}
            style={{
              display: play <= 1 ? 'block' : 'none',
            }}
            src={ImgPoint}
            alt=""
          />
          <div
            className="animation015-indicate"
            style={{ backgroundColor: itm.color }}
          >
            <div className="animation015-arrow">
              <img src={imageArrow} alt="" />
            </div>
            <div
              className="animation015-icon"
              style={{ backgroundColor: ' white' }}
            >
              <div className="number" style={{ color: itm.color }}>
                0{idx + 1}
              </div>
            </div>
            <div
              className="animation015-text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Animation015;
